import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import { LinkContext } from "../../LinkProvider";
import girl from "../../img/Home/girl.webp";
import Fade from 'react-reveal/Fade';

const contactItems = [
  { key: "assistance.email", icon: "mail" },
  { key: "assistance.phone", icon: "phone" },
  { key: "assistance.chat", icon: "chat" },
];

function ContactIcon({ type }) {
  if (type === "mail") {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M19.84 6.50267L19.75 6.14267C19.6308 5.793 19.4731 5.45761 19.28 5.14267C18.8409 4.40951 18.2121 3.80839 17.46 3.40267L12.21 0.562669C11.5158 0.19322 10.7414 0 9.955 0C9.16859 0 8.39422 0.19322 7.7 0.562669L2.45 3.40267C1.69785 3.80839 1.0691 4.40951 0.63 5.14267C0.43446 5.45492 0.27986 5.79101 0.17 6.14267V6.28267C0.0580032 6.6831 0.000815615 7.09687 0 7.51267V15.1327C0.00264212 16.3916 0.503935 17.5983 1.39416 18.4885C2.28439 19.3787 3.49103 19.88 4.75 19.8827H15.25C15.8738 19.8827 16.4914 19.7598 17.0677 19.5211C17.644 19.2824 18.1677 18.9325 18.6088 18.4914C19.0498 18.0503 19.3997 17.5267 19.6384 16.9504C19.8771 16.3741 20 15.7564 20 15.1327V7.50267C19.9821 7.16463 19.9284 6.82943 19.84 6.50267ZM11.58 9.85267C11.0843 10.1331 10.5245 10.2805 9.955 10.2805C9.38549 10.2805 8.82567 10.1331 8.33 9.85267L1.8 6.07267C1.83 5.996 1.86667 5.92267 1.91 5.85267C2.21181 5.3506 2.6437 4.93943 3.16 4.66267L8.41 1.82267C8.88239 1.56529 9.41204 1.43116 9.95 1.43267C10.4911 1.43119 11.024 1.56527 11.5 1.82267L16.75 4.66267C17.3677 4.99663 17.8594 5.52338 18.15 6.16267L11.58 9.85267Z" fill="#05193A"/>
      </svg>
    );
  }

  if (type === "phone") {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M6 3C5.20435 3 4.44129 3.31607 3.87868 3.87868C3.31607 4.44129 3 5.20435 3 6L3 8.4C3 15.3588 8.6412 21 15.6 21H18C18.7956 21 19.5587 20.6839 20.1213 20.1213C20.6839 19.5587 21 18.7956 21 18V16.3416C21 16.0071 20.9068 15.6793 20.7309 15.3949C20.5549 15.1104 20.3032 14.8806 20.004 14.7312L17.106 13.2816C16.8753 13.1663 16.6224 13.1018 16.3647 13.0927C16.1069 13.0836 15.8501 13.13 15.6118 13.2288C15.3735 13.3276 15.1593 13.4764 14.9835 13.6652C14.8078 13.8541 14.6747 14.0784 14.5932 14.3232L14.2356 15.3948C14.1698 15.5915 14.0345 15.7574 13.8551 15.8614C13.6758 15.9655 13.4646 16.0005 13.2612 15.96C11.9731 15.7019 10.7901 15.0685 9.86107 14.1397C8.93203 13.2109 8.29843 12.028 8.04 10.74C7.99949 10.5366 8.03454 10.3254 8.13859 10.1461C8.24264 9.96669 8.40855 9.83141 8.6052 9.7656L9.936 9.3216C10.3661 9.17799 10.7261 8.87735 10.9441 8.4798C11.1621 8.08224 11.2221 7.61705 11.112 7.1772L10.4088 4.3644C10.3117 3.97502 10.0872 3.62926 9.7711 3.38206C9.45498 3.13485 9.06531 3.00038 8.664 3H6Z" fill="#05193A"/>
      </svg>
    );
  }

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M10 3H14C16.1217 3 18.1566 3.84285 19.6569 5.34315C21.1571 6.84344 22 8.87827 22 11C22 13.1217 21.1571 15.1566 19.6569 16.6569C18.1566 18.1571 16.1217 19 14 19V22.5C9 20.5 2 17.5 2 11C2 8.87827 2.84285 6.84344 4.34315 5.34315C5.84344 3.84285 7.87827 3 10 3Z" fill="#05193A"/>
    </svg>
  );
}

function Assistance() {
  const { link } = useContext(LinkContext);
  const { t } = useTranslation();

  return (
    <section className="">
      <Fade bottom>
      <div className="relative mx-auto min-h-[577px] w-full max-w-[1220px] overflow-hidden px-[20px] pt-[26px] md:flex md:min-h-[360px] md:items-end md:justify-center md:gap-[126px] md:px-5 md:pt-0 xl:min-h-[394px]">
        <img
          src={girl}
          alt={t("assistance.imageAlt")}
          className="absolute bottom-0 left-1/2 h-auto w-[295px] -translate-x-1/2 md:static md:w-[315px] md:translate-x-0"
        />

        <div className="relative z-10 md:mb-[98px] md:w-[430px]">
          <h2 className="font-['Nunito_Sans'] text-[28px] font-black leading-[1.5] text-[#3273B4] md:text-[42px]">
            {t("assistance.title")}
          </h2>
          <span className="mt-[6px] block h-[2px] w-[86px] bg-[#05193A] md:mt-[8px] md:h-[4px] md:w-[98px]" />
          <h3 className="mt-[22px] font-['Nunito_Sans'] text-[16px] font-black leading-[1.5] text-[#05193A] md:mt-[20px] md:text-[21px]">
            {t("assistance.contact")}
          </h3>
          <div className="mt-[14px] flex flex-col gap-[13px] md:mt-[12px] md:gap-[14px]">
            {contactItems.map((item) => (
              <div key={item.key} className="flex items-center gap-[11px] font-['Nunito_Sans'] text-[14px] font-light leading-[1.5] text-[#05193A] md:text-[16px]">
                <ContactIcon type={item.icon} />
                <span>{item.icon === "mail" ? `support@${window.location.hostname}` : t(item.key)}</span>
              </div>
            ))}
          </div>
          <a
            href={link}
            className="mt-[18px] inline-flex h-[40px] items-center justify-center rounded-[9px] bg-[#05193A] px-[29px] font-[Inter] text-[14px] font-light text-white transition-colors hover:bg-[#0d2c60] md:hidden"
          >
            {t("header.openAccount")}
          </a>
        </div>
      </div>
      </Fade>
    </section>
  );
}

export default Assistance;
